<template>
  <div class="container">
    <!-- <div class="contentBox">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="22" :sm="20" :md="16">
          <div class="title">{{ $t("pilotService.title") }}</div>
          <div class="content">
            珠海翔翼航空技术有限公司是中国南方航空股份有限公司（简称“南航”）的全资子公司，前身是1992年成立的南航珠海飞行训练中心，2003年南航与加拿大CAE合资成立翔翼公司，2017年8月南航回购全部股份，成为全资子公司。
          </div>
          <div class="plant">
            <div v-for="item in planData" :key="item.id" :class="item.className" @click="goToPath(item)">
              <div>
                <img class="plant-img" :src="item.img"/>
              </div>
              <div class="plant-title">{{ item.title }}</div>
              <div class="plant-introduction">一步一个计划，让工作与生活更有规划，快来查询你的计划吧~~</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div> -->

    <div>
      <img
        class="backImg"
        :src="
          language === 'zh'
            ? require('@/assets/images/pilotService/custcomService.jpg')
            : require('@/assets/images/pilotService/en_custcomService.jpg')
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="18" :md="18">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>
    <div class="serve">
      <!-- <div class="serve-left">
        <div class="serve-title">{{ $t("pilotService.otherTitle") }}</div>
        <div class="serve-introduction">
          其他服务描述信息：提供自助打印、交通指引、失物招领、问卷调查服务。方便飞行员使用服务。
        </div>
      </div> -->
      <!-- <div class="serve-right"> -->
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="18" :md="18">
          <el-row :gutter="30" style="margin: 20px 0 40px 0">
            <el-col
              :xs="12"
              :sm="8"
              :md="8"
              v-for="item in otherData"
              :key="item.id"
            >
              <div class="serve-list" @click="goToPath(item)">
                <!-- <div
          class="serve-list"
          v-for="item in otherData"
          :key="item.id"
          @click="goToPath(item)"
        > -->
                <!-- <div>
            <img class="serve-list-img" :src="item.img" />
          </div>
          <div class="serve-list-title">{{ item.title }}</div>
          <div class="serve-list-content">
            一步一个计划，让工作与生活更有规划，快来查询你的计划吧~~
          </div> -->
                <div>
                  <img class="list-img" :src="item.img" />
                </div>
              </div>
              <!-- </div> -->
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { localStorage } from "@/utils/storage.js";
export default {
  data() {
    return {
      language: localStorage.get("language") || "zh",
      planData: [
        {
          id: "1",
          name: "模拟机计划查询",
          title: `${this.$t("pilotService.PlanQuery")}`,
          className: "plant-left",
          img: require("@/assets/images/pilotService/plan.png"),
          path: "/pilotService/planQuery",
        },
        {
          id: "2",
          name: "理论计划查询",
          title: `${this.$t("pilotService.TheoreticalPlan")}`,
          className: "plant-right",
          img: require("@/assets/images/pilotService/TheoreticalPlan.png"),
          path: "/pilotService/planQuery/second",
        },
      ],
      otherData: [
        // {
        //   id:'1',
        //   name:'自助打印',
        //   title:`${this.$t("pilotService.SelfServicePrinting")}`,
        //   img:require('@/assets/images/pilotService/print.png'),
        //   path:''
        // },
        // {
        //   id: "8",
        //   name: "模拟机计划查询",
        //   title: `${this.$t("pilotService.PlanQuery")}`,
        //   className: "plant-left",
        //   img:
        //     localStorage.get("language") === "zh"
        //       ? require("@/assets/images/pilotService/PlanQuery.jpg")
        //       : require("@/assets/images/pilotService/en_PlanQuery.jpg"),
        //   path: "/pilotService/planQuery",
        // },
        // {
        //   id: "9",
        //   name: "理论计划查询",
        //   title: `${this.$t("pilotService.TheoreticalPlan")}`,
        //   className: "plant-right",
        //   img:
        //     localStorage.get("language") === "zh"
        //       ? require("@/assets/images/pilotService/TheoreticalPlan.jpg")
        //       : require("@/assets/images/pilotService/en_TheoreticalPlan.jpg"),
        //   path: "/pilotService/planQuery/second",
        // },
        // {
        //   id: "2",
        //   name: "交通指引",
        //   title: `${this.$t("pilotService.TrafficGuidance")}`,
        //   img: require("@/assets/images/pilotService/otherData.png"),
        //   path: "/pilotService/trafficGuidance",
        // },
        // {
        //   id: "3",
        //   name: "失物招领",
        //   title: `${this.$t("pilotService.LostAndFound")}`,
        //   img: require("@/assets/images/pilotService/LostAndFound.png"),
        //   path: "/pilotService/lostFound",
        // },
        // {
        //   id: "4",
        //   name: "问卷调查",
        //   title: `${this.$t("pilotService.QuestionnaireInvestigation")}`,
        //   img:
        //     localStorage.get("language") === "zh"
        //       ? require("@/assets/images/pilotService/QuestionnaireInvestigation.jpg")
        //       : require("@/assets/images/pilotService/en_QuestionnaireInvestigation.jpg"),
        //   path: "/pilotService/questionnaireInvestigation",
        // },
        // {
        //   id: "5",
        //   name: "训练须知",
        //   title: `${this.$t("pilotService.Training")}`,
        //   img:
        //     localStorage.get("language") === "zh"
        //       ? require("@/assets/images/pilotService/xunlian.jpg")
        //       : require("@/assets/images/pilotService/en_xunlian.jpg"),
        //   path: "/pilotService/articleCenter/3011",
        // },
        // {
        //   id:'6',
        //   name:'园区服务建议',
        //   title:`${this.$t("pilotService.ParkServiceSuggestions")}`,
        //   img:require('@/assets/images/pilotService/yuanqu.png'),
        //   path:'/pilotService/articleCenter/3012'
        // },
        {
          id: "7",
          name: "在线学习系统",
          title: `${this.$t("pilotService.OnlineLearningSystem")}`,
          img:
            localStorage.get("language") === "zh"
              ? require("@/assets/images/pilotService/jiaoyu.jpg")
              : require("@/assets/images/pilotService/en_jiaoyu.jpg"),
          path: "https://xylms.zhftc.com",
        },
      ],
    };
  },
  computed: {
    language() {
      return localStorage.get("language") || "zh";
    },
  },
  methods: {
    goToPath(data) {
      if (data.id === "7") {
        window.open(data.path, "_blank");
        return;
      }
      if (data.path) {
        this.$router.push(data.path);
        this.$emit("resetScrollTop");
      }
    },
    linkPlanQuery() {
      this.$router.push({ path: "/pilotService/planQuery" });
      this.$emit("resetScrollTop");
    },
    linkLostFound() {
      this.$router.push({ path: "/pilotService/lostFound" });
      this.$emit("resetScrollTop");
    },
    linkTrafficGuidance() {
      this.$router.push({ path: "/pilotService/trafficGuidance" });
      this.$emit("resetScrollTop");
    },
    linkQuestionnaire() {
      this.$router.push({ path: "/pilotService/questionnaireInvestigation" });
      this.$emit("resetScrollTop");
    },
  },
};
</script>

<style scoped>
.container {
  /* margin-bottom: 30px; */
}
.backImg {
  width: 100%;
  /* height: 300px; */
}
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.contentBox {
  width: 100%;
  padding: 30px 0;
  margin: 0 auto;
}
.title {
  text-align: center;
  font-family: "Arial Black", "Arial Normal", "Arial";
  font-weight: 900;
  font-style: normal;
  font-size: 30px;
  letter-spacing: 6px;
  color: #000000;
  height: 60px;
}
.content {
  text-align: center;
  height: 129px;
  display: flex;
  font-size: 16px;
  letter-spacing: 2px;
  color: #000000;
  line-height: 34px;
  padding: 10px;
}
.plant {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
}
.plant-left {
  width: 40%;
  cursor: pointer;
  background-color: rgba(231, 242, 255, 1);
  height: 250px;
  border-radius: 10px;
  padding: 2% 4%;
}
.plant-img {
  width: 80px;
}
.plant-title {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  font-weight: 700;
  font-style: normal;
  font-size: 26px;
  color: #0f3aa6;
  text-align: left;
  line-height: 100px;
}
.plant-introduction {
  font-size: 15px;
}
.plant-right {
  cursor: pointer;
  width: 40%;
  background-color: rgba(231, 242, 255, 1);
  height: 250px;
  padding: 2% 4%;
  border-radius: 10px;
}
.serve {
  /* background: url("../../assets/images/pilotService/serve-back.jpg") top center no-repeat; */
  /* background-size: 100% 100%; */
  /* background-color: #28467f; */
  /* display: flex; */
  background: url("../../assets/images/home/lunbobg.jpg") top center no-repeat;
  background-size: 100% 100%;
  height: auto;
  /* padding: 6% 15.5%; */
  /* margin-top: -60px; */
}
.serve-left {
  /* width: 40%; */
  width: 100%;
  text-align: center;
  margin-bottom: 40px;
}
.serve-title {
  font-family: "Arial Black", "Arial Normal", "Arial";
  font-weight: 900;
  font-style: normal;
  font-size: 32px;
  letter-spacing: 6px;
  color: #ffffff;
  text-align: center;
  height: 80px;
}
.serve-introduction {
  font-size: 16px;
  letter-spacing: 2px;
  color: #ffffff;
  text-align: justify;
  text-align: center;
  line-height: 40px;
}
.serve-more {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  font-size: 18px;
  width: 140px;
  line-height: 40px;
  margin-top: 80px;
  text-align: center;
  color: #444444;
}
.serve-right {
  display: flex;
  flex-wrap: wrap;
  column-gap: 30px;
  row-gap: 30px;
  /* justify-content: space-between; */
  align-items: center;
  width: 100%;
}
.serve-list {
  /* background-color: rgba(15, 58, 166, 1); */
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  font-weight: 700;
  font-style: normal;
  cursor: pointer;
  /* border-radius: 10px; */
  /* width: 20vw; */
  /* height: auto; */
  height: 15vmax;
  font-size: 30px;
  color: #ffffff;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 8px rgb(58 153 229 / 35%);
  margin-top: 30px;
}
/* .serve-list:nth-last-child(1) {
  margin-bottom: 0;
} */
.list-img {
  position: absolute;
  width: 100%;
  height: 100%;
}
.list-img:hover {
  animation-name: scaleDraw;
  animation-duration: 1s;
  transform: scale(1.15);
}
@keyframes scaleDraw {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.15);
  }
}
.serve-list-img {
  width: 50px;
  margin: 10% 0;
  /* margin-bottom: 10%; */
}
.serve-list-title {
  font-size: 22px;
  margin-bottom: 10%;
  /* line-height: 55px; */
}
.serve-list-content {
  font-size: 13px;
  line-height: 25px;
  min-height: 90px;
}
/* 响应式样式 */
@media only screen and (max-width: 768px) {
  .backImg {
    width: 100%;
    height: auto;
  }
  .contentBox {
    width: 100%;
  }
  .title {
    font-size: 18px;
    height: 40px;
  }
  .content {
    font-size: 13px;
    line-height: 22px;
  }
  .plant-left {
    width: 36%;
    height: 160px;
    border-radius: 10px;
    padding: 10px 20px;
  }
  .plant-img {
    width: 40px;
  }
  .plant-title {
    font-size: 14px;
    margin-top: 10px;
    line-height: 20px;
    height: 50px;
  }
  .plant-introduction {
    font-size: 12px;
  }
  .plant-right {
    width: 36%;
    height: 160px;
    border-radius: 10px;
    padding: 10px 20px;
  }
  .serve {
    /* display: block;
    height: auto;
    padding: 15px; */
  }
  .serve-left {
    width: 100%;
  }
  .serve-title {
    font-size: 24px;
    letter-spacing: 6px;
    height: 60px;
  }
  .serve-introduction {
    font-size: 13px;
    letter-spacing: 2px;
    line-height: 30px;
    text-align: justify;
  }
  .serve-more {
    font-size: 15px;
    width: 110px;
    line-height: 40px;
    margin-top: 20px;
  }
  .serve-right {
    /* display: flex;
    flex-wrap: wrap;
    column-gap: 0;
    row-gap: 0; */
    /* justify-content: space-between; */
    /* align-items: center;
    margin-top: 40px;
    width: 100%; */
  }

  .serve-list {
    font-size: 15px;
    margin-top: 10px;
    height: 25vw;
  }

  .serve-list-img {
    width: 30px;
  }
  .serve-list-title {
    font-size: 17px;
    margin-top: 10px;
    line-height: 25px;
    height: 50px;
  }
  .serve-list-content {
    font-size: 12px;
    line-height: 18px;
  }
}

@media screen and (min-width: 768px) {
}
@media screen and (min-width: 992px) {
}

@media screen and (min-width: 1200px) {
}

@media screen and (min-width: 1400px) {
}

@media screen and (min-width: 1920px) {
}
</style>